import React from 'react';
import ReactDOM from 'react-dom/client';
import './static/css/index.css';
import App from './App';
import Aside from './components/Aside';
import './i18n';
import reportWebVitals from './reportWebVitals';
import { initializeGTM } from './gtm';

initializeGTM();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Aside />
    <App />
  </React.StrictMode>
);

reportWebVitals((metric) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'web-vitals',
      metric: { name: metric.name, value: metric.value, id: metric.id },
    });
  }
});
